import React from 'react';
import { BaseFilter, BaseFilterProps } from '../../common/BaseFilter';
import { t } from '../../../../../types/translation/Translator';
import { CustomFieldTypeFilterDropdownContent, CustomFieldTypeFilterInnerContent } from './DropdownContent';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { CustomFieldType, CustomFieldUtil } from '../../../../../types/custom_field';
import { itemsContainText } from '../../../../../util/string.util';

export class CustomFieldTypeFilter extends BaseFilter<CustomFieldType> {
  toLabel(): string {
    return t(TranslationKey.type).singular.label;
  }

  toIcon(): React.JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <CustomFieldTypeFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CustomFieldTypeFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: CustomFieldType, query: string): boolean {
    return itemsContainText(query, [item, CustomFieldUtil.customFieldTypeToString(item)]);
  }

  toCount(): number {
    return 0;
  }
}
